<template>
    <div v-if="total" class="block" :class="`p-t-${paddingTop}`">
        <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        />
    </div>
</template>

<script>
export default {
    name: 'Page',
    props: {
        paddingTop: {
            type: Number,
            default: 30
        },
        total: {
            type: Number,
            default: null
        },
        pageSize: {
            type: Number,
            default: 10
        },
        pageNum: {
            type: Number,
            default: 1
        }
    },
    methods: {
        handleSizeChange(val) {
            this.$emit('sizeChange', val);
        },
        handleCurrentChange(val) {
            this.$emit('currentChange', val);
        }
    }
};
</script>

<style lang="scss" scoped>
.block {
    .el-pagination {
        text-align: right;
        ::v-deep {
            .el-pager li {
                background-color: transparent;
                font-size: 15px;
                font-family: PingFang_Medium;
                font-weight: 500;
                color: #848e9c;
                padding: 0;
                min-width: 30px;
                height: 30px;
                line-height: 30px;
                margin-right: 10px;
                &:last-child {
                    margin-right: 0;
                }
            }
            .el-pager li.active {
                background-color: $basicColor;
                color: #0c0c11;
                border-radius: 4px;
                box-shadow: 0px 24px 30px 0px rgba(82, 92, 229, 0.19);
            }
            button {
                height: 30px;
                line-height: 30px;
                min-width: 30px;
                padding: 0 9px 0;
                // color: #848E9C;
            }
            .btn-prev {
                margin-right: 10px;
            }
            .btn-next {
                margin-left: 10px;
            }
        }
    }
}
</style>
